import React, { useEffect, useState } from "react";
import { styled } from "styled-components";
import Spinner from "../img/loading.mp4";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import config from "../config.js";
import ModalRejoinBlocked from "./Modal/ModalRejoinBlocked.jsx";
import {
  clearSignupAttribution,
} from "../utils/attribution.js";
import { isWithdrawnUserHttpError } from "../utils/oauthError.js";
import {
  completeGuestChatHandoff,
  hasPendingGuestChatHandoff,
} from "../utils/guestChatHandoff.js";

const KakaoRedirect = () => {
  // REACT_APP_SERVER_DOMAIN_DEV
  // REACT_APP_SERVER_DOMAIN_DEPLOY

  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  // const SERVER_IP = "192.168.0.4:8080"; // 배포 전
  // const SERVER_URI = process.env.REACT_APP_SERVER_DOMAIN_DEPLOY; // 배포 후
  //const SERVER_URI = process.env.REACT_APP_SERVER_DOMAIN_DEV;
  const SERVER_URI = config.serverUri;
  const REDIRECT_SERVER_URI = `${SERVER_URI}/login/kakao`;

  useEffect(() => {
    const loginInfo = Cookies.get("lawlow"); // 로그인 정보가 있다면 앱 가이드 페이지로 리디렉트
    const hasPendingHandoff = hasPendingGuestChatHandoff();
    if (loginInfo && !hasPendingHandoff) {
      // 가이드를 이미 본 사용자는 바로 메인으로
      const hasSeenGuide = localStorage.getItem("hasSeenAppGuide");
      if (hasSeenGuide === "true") {
        navigate("/main", { replace: true });
      } else {
        navigate("/app-guide");
      }
    } else {
      if (window.location.pathname === "/oauth/kakao") {
        const searchParams = new URL(document.location.toString()).searchParams;
        const code = searchParams.get("code");
        const state = searchParams.get("state");
        if (!code || !state) {
          alert("잘못된 접근입니다. 홈페이지 첫 화면으로 이동합니다.");
          navigate("/", { replace: true });
          return;
        }
        handleOAuthRedirect(code, state);
      }
    }
  }, []);

  // 서버측에 인가 코드 전달
  function handleOAuthRedirect(code, state) {
    // 현재 환경에 따라 redirect_source 설정
    const redirectSource = ["localhost", "127.0.0.1"].includes(window.location.hostname)
      ? "localhost"
      : "front";

    // 세션에서 초대 코드 가져오기
    const referralCode = sessionStorage.getItem('referralCode');

    // state 파라미터 구성 (초대 코드가 있으면 포함)
    const params = new URLSearchParams({
      code,
      state,
      redirect_source: redirectSource,
    });
    const url = `${REDIRECT_SERVER_URI}?${params.toString()}`;

    axios
      .get(url, { withCredentials: true })
      .then(async () => {
        // 로그인 성공 시 세션에서 초대 코드 제거
        if (referralCode) {
          sessionStorage.removeItem('referralCode');
        }
        clearSignupAttribution();
        const hadPendingHandoff = hasPendingGuestChatHandoff();
        if (hadPendingHandoff) {
          await completeGuestChatHandoff().catch((error) => {
            console.error("비로그인 채팅 이어가기 실패:", error);
          });
          navigate("/main", { replace: true });
          return;
        }
        // 메인 페이지에서 trackLogin 처리하므로 여기서는 호출하지 않음
        // response 비어있어도 됨

        // 가이드를 이미 본 사용자는 바로 메인으로
        const hasSeenGuide = localStorage.getItem("hasSeenAppGuide");
        if (hasSeenGuide === "true") {
          navigate("/main", { replace: true });
        } else {
          navigate("/app-guide"); // 로그인 성공시 앱 가이드 페이지로 이동
        }
      })
      .catch((error) => {
        if (isWithdrawnUserHttpError(error)) {
          setShowModal(true);
        } else {
          // 다른 에러의 경우 기존 처리
          console.error("Login error:", error);
          navigate("/");
        }
      });
  }

  return (
    <>
      <Wrapper>
        <ResponsiveVideo autoPlay loop muted playsInline>
          <source src={Spinner} type="video/mp4" />
        </ResponsiveVideo>
        <Text>
          <Highlight>로그인하는중</Highlight>
          <br />
          잠시만 기다려주세요
        </Text>
      </Wrapper>
      <ModalRejoinBlocked 
        isOpen={showModal} 
        onClose={() => setShowModal(false)} 
      />
    </>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  font-weight: 500;
  overflow: hidden; /* 스크롤 막기 */
`;

const Text = styled.div`
  color: rgba(0, 0, 0, 0.6);
  text-align: center;
  font-style: normal;
  font-weight: 500;
  font-size: 25px;
  line-height: 60px;

  @media (max-width: 599px) {
    font-size: 14px;
    line-height: 32px;
  }
`;

const Highlight = styled.span`
  font-size: 48px;
  font-weight: 700;
  color: rgba(0, 0, 0, 0.8);

  @media (max-width: 599px) {
    font-size: 24px;
    line-height: 23px;
  }
`;

const ResponsiveVideo = styled.video`
  width: 320px;
  height: 320px;

  @media (max-width: 599px) {
    width: 150px;
    height: 150px;
  }
`;

export default KakaoRedirect;
